var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 705,
    height: 1517,
    viewBox: "0 0 705 1517",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_337_487)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_337_487)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18,
    width: 742,
    height: 1529,
    rx: 18,
    fill: "#162C67"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_337_487)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.715,
    y: 460.718,
    width: 276.954,
    height: 359.555,
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.444,
    y: 509.316,
    width: 194.352,
    height: 14.5764,
    rx: 4,
    fill: "#2E2B2B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 572.477,
    width: 87.4584,
    height: 14.5764,
    rx: 4,
    fill: "#2E2B2B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.441,
    y: 548.181,
    width: 87.4584,
    height: 63.1644,
    rx: 2,
    fill: "#2E2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215 457C215 453.686 217.686 451 221 451H510.249C513.563 451 516.249 453.686 516.249 457V828.849C516.249 832.163 513.563 834.849 510.249 834.849H221C217.686 834.849 215 832.163 215 828.849V457ZM229.581 468.567C229.581 466.911 230.924 465.567 232.581 465.567H498.676C500.333 465.567 501.676 466.911 501.676 468.567V817.263C501.676 818.92 500.333 820.264 498.676 820.264H232.581C230.924 820.264 229.581 818.92 229.581 817.264V468.567Z",
    fill: "#2E2B2B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.441,
    y: 635.637,
    width: 194.352,
    height: 14.5764,
    rx: 4,
    fill: "#2E2B2B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.441,
    y: 698.794,
    width: 194.352,
    height: 14.5764,
    rx: 4,
    fill: "#2E2B2B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.441,
    y: 761.967,
    width: 53.4468,
    height: 14.5764,
    rx: 4,
    fill: "#2E2B2B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.535,
    y: 891.454,
    width: 38.8704,
    height: 96.4923,
    transform: "rotate(-44.9142 506.535 891.454)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.572,
    y: 839.703,
    width: 37.4439,
    height: 14.5764,
    rx: 4,
    transform: "rotate(45.8565 497.572 839.703)",
    fill: "#2E2B2B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 453.109,
    cy: 800.823,
    rx: 72.882,
    ry: 72.882,
    fill: "#D1F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.118 878.565C496.053 878.565 530.858 843.76 530.858 800.825C530.858 757.89 496.053 723.084 453.118 723.084C410.183 723.084 375.377 757.89 375.377 800.825C375.377 843.76 410.183 878.565 453.118 878.565ZM453.122 863.98C488.007 863.98 516.286 835.701 516.286 800.816C516.286 765.931 488.007 737.651 453.122 737.651C418.237 737.651 389.958 765.931 389.958 800.816C389.958 835.701 418.237 863.98 453.122 863.98Z",
    fill: "#2E2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M495.872 883.544C494.31 885.106 494.31 887.639 495.872 889.201L576.495 969.824C578.057 971.386 580.59 971.386 582.152 969.824L616.678 935.299C618.24 933.737 618.24 931.204 616.678 929.642L536.054 849.018C534.492 847.456 531.959 847.456 530.397 849.018L495.872 883.544ZM515.269 885.357C514.879 885.747 514.879 886.381 515.269 886.771L578.704 950.206C579.095 950.596 579.728 950.596 580.118 950.206L597.62 932.704C598.01 932.314 598.01 931.681 597.62 931.29L534.185 867.855C533.795 867.465 533.161 867.465 532.771 867.855L515.269 885.357Z",
    fill: "#2E2B2B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_337_487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.888 967.2V1037H218.888V1007.3H188.988V1037H174.988V967.2H188.988V995.9H218.888V967.2H232.888ZM298.168 1008.1C298.168 1010.1 298.034 1011.9 297.768 1013.5H257.268C257.601 1017.5 259.001 1020.63 261.468 1022.9C263.934 1025.17 266.968 1026.3 270.568 1026.3C275.768 1026.3 279.468 1024.07 281.668 1019.6H296.768C295.168 1024.93 292.101 1029.33 287.568 1032.8C283.034 1036.2 277.468 1037.9 270.868 1037.9C265.534 1037.9 260.734 1036.73 256.468 1034.4C252.268 1032 248.968 1028.63 246.568 1024.3C244.234 1019.97 243.068 1014.97 243.068 1009.3C243.068 1003.57 244.234 998.533 246.568 994.2C248.901 989.867 252.168 986.533 256.368 984.2C260.568 981.867 265.401 980.7 270.868 980.7C276.134 980.7 280.834 981.833 284.968 984.1C289.168 986.367 292.401 989.6 294.668 993.8C297.001 997.933 298.168 1002.7 298.168 1008.1ZM283.668 1004.1C283.601 1000.5 282.301 997.633 279.768 995.5C277.234 993.3 274.134 992.2 270.468 992.2C267.001 992.2 264.068 993.267 261.668 995.4C259.334 997.467 257.901 1000.37 257.368 1004.1H283.668ZM322.386 990.2C324.186 987.267 326.52 984.967 329.386 983.3C332.32 981.633 335.653 980.8 339.386 980.8V995.5H335.686C331.286 995.5 327.953 996.533 325.686 998.6C323.486 1000.67 322.386 1004.27 322.386 1009.4V1037H308.386V981.6H322.386V990.2ZM417.616 980.8C424.416 980.8 429.883 982.9 434.016 987.1C438.216 991.233 440.316 997.033 440.316 1004.5V1037H426.316V1006.4C426.316 1002.07 425.216 998.767 423.016 996.5C420.816 994.167 417.816 993 414.016 993C410.216 993 407.183 994.167 404.916 996.5C402.716 998.767 401.616 1002.07 401.616 1006.4V1037H387.616V1006.4C387.616 1002.07 386.516 998.767 384.316 996.5C382.116 994.167 379.116 993 375.316 993C371.449 993 368.383 994.167 366.116 996.5C363.916 998.767 362.816 1002.07 362.816 1006.4V1037H348.816V981.6H362.816V988.3C364.616 985.967 366.916 984.133 369.716 982.8C372.583 981.467 375.716 980.8 379.116 980.8C383.449 980.8 387.316 981.733 390.716 983.6C394.116 985.4 396.749 988 398.616 991.4C400.416 988.2 403.016 985.633 406.416 983.7C409.883 981.767 413.616 980.8 417.616 980.8ZM505.101 1008.1C505.101 1010.1 504.968 1011.9 504.701 1013.5H464.201C464.535 1017.5 465.935 1020.63 468.401 1022.9C470.868 1025.17 473.901 1026.3 477.501 1026.3C482.701 1026.3 486.401 1024.07 488.601 1019.6H503.701C502.101 1024.93 499.035 1029.33 494.501 1032.8C489.968 1036.2 484.401 1037.9 477.801 1037.9C472.468 1037.9 467.668 1036.73 463.401 1034.4C459.201 1032 455.901 1028.63 453.501 1024.3C451.168 1019.97 450.001 1014.97 450.001 1009.3C450.001 1003.57 451.168 998.533 453.501 994.2C455.835 989.867 459.101 986.533 463.301 984.2C467.501 981.867 472.335 980.7 477.801 980.7C483.068 980.7 487.768 981.833 491.901 984.1C496.101 986.367 499.335 989.6 501.601 993.8C503.935 997.933 505.101 1002.7 505.101 1008.1ZM490.601 1004.1C490.535 1000.5 489.235 997.633 486.701 995.5C484.168 993.3 481.068 992.2 477.401 992.2C473.935 992.2 471.001 993.267 468.601 995.4C466.268 997.467 464.835 1000.37 464.301 1004.1H490.601ZM536.52 1037.9C531.987 1037.9 527.92 1037.1 524.32 1035.5C520.72 1033.83 517.853 1031.6 515.72 1028.8C513.653 1026 512.52 1022.9 512.32 1019.5H526.42C526.687 1021.63 527.72 1023.4 529.52 1024.8C531.387 1026.2 533.687 1026.9 536.42 1026.9C539.087 1026.9 541.153 1026.37 542.62 1025.3C544.153 1024.23 544.92 1022.87 544.92 1021.2C544.92 1019.4 543.987 1018.07 542.12 1017.2C540.32 1016.27 537.42 1015.27 533.42 1014.2C529.287 1013.2 525.887 1012.17 523.22 1011.1C520.62 1010.03 518.353 1008.4 516.42 1006.2C514.553 1004 513.62 1001.03 513.62 997.3C513.62 994.233 514.487 991.433 516.22 988.9C518.02 986.367 520.553 984.367 523.82 982.9C527.153 981.433 531.053 980.7 535.52 980.7C542.12 980.7 547.387 982.367 551.32 985.7C555.253 988.967 557.42 993.4 557.82 999H544.42C544.22 996.8 543.287 995.067 541.62 993.8C540.02 992.467 537.853 991.8 535.12 991.8C532.587 991.8 530.62 992.267 529.22 993.2C527.887 994.133 527.22 995.433 527.22 997.1C527.22 998.967 528.153 1000.4 530.02 1001.4C531.887 1002.33 534.787 1003.3 538.72 1004.3C542.72 1005.3 546.02 1006.33 548.62 1007.4C551.22 1008.47 553.453 1010.13 555.32 1012.4C557.253 1014.6 558.253 1017.53 558.32 1021.2C558.32 1024.4 557.42 1027.27 555.62 1029.8C553.887 1032.33 551.353 1034.33 548.02 1035.8C544.753 1037.2 540.92 1037.9 536.52 1037.9Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_337_487",
    x: -22,
    y: 0,
    width: 750,
    height: 1537,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_337_487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_337_487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_337_487",
    x: 211,
    y: 451,
    width: 410.85,
    height: 527.996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_337_487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_337_487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_337_487",
    x: 170.988,
    y: 967.2,
    width: 391.332,
    height: 78.7002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_337_487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_337_487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_337_487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 705,
    height: 1517,
    rx: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplash);
export default __webpack_public_path__ + "static/media/splash.45d95eb58b2259e6f7f111c883dc9dbd.svg";
export { ForwardRef as ReactComponent };